export default __webpack_public_path__ + "static/media/Credit.45834461.svg";